import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X, Crown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { startCheckout } from "@/lib/checkout";

const MALE = ["man", "male"];

export function UpgradeBanner() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    let active = true;
    (async () => {
      if (!user) { setShow(false); return; }
      if (sessionStorage.getItem("pula_upgrade_dismissed") === "1") return;
      try {
        const [me, plus] = await Promise.all([
          api.get("/love/me"),
          api.get("/payments/plus-status"),
        ]);
        const gender = (me.data?.gender || "").trim().toLowerCase();
        if (active && MALE.includes(gender) && !plus.data?.is_plus) setShow(true);
      } catch { /* noop */ }
    })();
    return () => { active = false; };
  }, [user]);

  if (!show) return null;
  // Keep the care-jobs focus clean: no dating upsell on the homepage or care pages
  if (pathname === "/" || pathname.startsWith("/care")) return null;

  const dismiss = () => { sessionStorage.setItem("pula_upgrade_dismissed", "1"); setShow(false); };

  return (
    <div data-testid="upgrade-banner" className="bg-pula-accent text-white">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3 text-sm">
        <Crown className="w-4 h-4 shrink-0" />
        <p className="flex-1 font-body">Unlock full Pula Love — message and connect with everyone for just £10/month.</p>
        <button data-testid="upgrade-banner-cta" onClick={() => startCheckout("pula_love_men_monthly", user?.user_id)}
          className="rounded-full bg-white text-pula-accent font-semibold px-3 py-1 text-xs hover:opacity-90 shrink-0 transition-opacity">Upgrade</button>
        <button data-testid="upgrade-banner-dismiss" onClick={dismiss} aria-label="Dismiss" className="shrink-0 opacity-80 hover:opacity-100 transition-opacity"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
